import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_HOME_SUMMARY,
  FETCH_HOME_SUMMARY_ERROR,
  SET_HOME_SUMMARY,
} from '../constants';

const homeSummary = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_HOME_SUMMARY),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/summary?${`since=${
          encodeURIComponent(state$.value.home.sinceDate)
        }&until=${encodeURIComponent(state$.value.home.untilDate)}`}&v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_HOME_SUMMARY,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_HOME_SUMMARY_ERROR,
            error,
          })
        )
      )
    )
  );

export default homeSummary;
